import { JobOffer } from 'job/job-offer';
import { JobOfferOutput } from 'job/model/job-offer.output';

export abstract class JobOfferConverterPort {
	public abstract jobOfferAsEntity(output: JobOfferOutput): JobOffer;

	public abstract jobOffersAsEntities(outputs: JobOfferOutput[]): JobOffer[];
}
